import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-rfis-wrapper',
    templateUrl: './rfis-wrapper.component.html',
    styleUrls: ['./rfis-wrapper.component.scss'],
    standalone: false
})
export class RfisWrapperComponent implements OnInit, OnDestroy {
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor() {
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
